export default __webpack_public_path__ + "static/media/Q6_3_resized.0a547ec9.jpg";